import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

const filterButtonIconContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	gap: 'space.075',
});

export const FilterButtonIconContainer = ({ children }: React.PropsWithChildren<{}>) => {
	return <Box xcss={filterButtonIconContainerStyles}>{children}</Box>;
};
